import { render, staticRenderFns } from "./CmgRewardExtrasGroupCampaignOptionCard.vue?vue&type=template&id=55dad468&scoped=true&lang=pug"
import script from "./cmg-reward-extras-group-campaign-option-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-extras-group-campaign-option-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardExtrasGroupCampaignOptionCard.vue?vue&type=style&index=0&id=55dad468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dad468",
  null
  
)

export default component.exports